import { useCallback } from "react"
import { graphql, useMutation } from "react-relay"
import {
  ReleasePatientFileLockInput,
  useReleasePatientFileLockMutation as useReleasePatientFileLockMutationType,
} from "@/modules/patients/services/__generated__/useReleasePatientFileLockMutation.graphql"

const releasePatientFileLockMutation = graphql`
  mutation useReleasePatientFileLockMutation($input: ReleasePatientFileLockInput!) {
    releasePatientFileLock(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      patientFileLockOutput {
        ...PatientFileLockOutputFragment
      }
    }
  }
`

const useReleasePatientFileLockMutation = () => {
  const [commit] = useMutation<useReleasePatientFileLockMutationType>(releasePatientFileLockMutation)

  return useCallback(
    (input: ReleasePatientFileLockInput, onCompleted?: () => void) => {
      return new Promise<void>((res) => {
        commit({
          variables: {
            input,
          },
          onCompleted(response) {
            const data = response.releasePatientFileLock
            if (!data.errors?.length) {
              onCompleted?.()
              res()
            }
          },
        })
      })
    },
    [commit],
  )
}

export { useReleasePatientFileLockMutation }
